import { IApiKeys, IApiService } from "../interfaces";

const ICDC_APIBaseURL: string = "https://api.apps.binus.ac.id/beelajar2"; 
const beelajar_APIBaseURL: string = "https://beelajarlms.apps.binus.edu/webservice/rest/server.php";
const imageMoodleToken = 'fa0b931c1a13c006a9534ada905ce2e7';
const BCLnDFrontEnd_APIBaseURL: string = "https://bcld.apps.binus.edu";
const BCLnDOldBackEnd_BaseURL: string = "https://bcld.binus.edu/CorpuBE";
const BCLnDNewBackEnd_APIBaseURL: string = "https://bcldbe.apps.binus.edu";
const Fma_APIBaseURL: string = "https://fma.apps.binus.edu";

export const ApiKeys: IApiKeys = {
  /* Azure AD Keys */
  azureAD_client_id: "b4e059d6-317a-471f-a417-20a74e0616cc",
  azureAD_tenant_id: "3485b963-82ba-4a6f-810f-b5cc226ff898",

  /* ICDC Keys */
  icdc_application_id: "",
  icdc_division_id: "97CBEE29-FEA3-4EAC-9B2F-C6A04546B2CE",

  beelajarToken1: 'fa0b931c1a13c006a9534ada905ce2e7',
  beelajarToken2: 'fa0b931c1a13c006a9534ada905ce2e7'
};

const setUrlBeelajar = (funct) => {
  return beelajar_APIBaseURL
    + '?moodlewsrestformat=json'
    + '&wstoken=' + ApiKeys.beelajarToken1
    + '&wsfunction=' + funct;
}

export const ApiService: IApiService = {
  azureAd: {
    instance: "https://login.microsoftonline.com/",
  },
  icdc: {
    auth: {
      getToken: ICDC_APIBaseURL + "/auth/token",
      userAuth: ICDC_APIBaseURL + "/auth/user",
      userLogin: ICDC_APIBaseURL + "/auth/login-manual",
      getBclndOldBeToken: ICDC_APIBaseURL + "/auth/get-old-bclnd-be-token"
    },
    general: {},
    module: {
      userManagement: {
        getListUserManagementData: ICDC_APIBaseURL + "/icdc/module/usermanagement/list",
      },
      roleManagement: {
        getListRolesData: ICDC_APIBaseURL + "/ms-role/get-list",
        getRoleData: ICDC_APIBaseURL + "/ms-role/get",
        updateRoleData: ICDC_APIBaseURL + "/ms-role/update",
        addRoleData: ICDC_APIBaseURL + "/ms-role/add",
        deleteRoleData: ICDC_APIBaseURL + "/ms-role/del",
        searchUsers: ICDC_APIBaseURL + "/ms-role/search-user",
        getListUsersData: ICDC_APIBaseURL + "/ms-role/get-role-user-list",
        getRoleUserData: ICDC_APIBaseURL + "/ms-role/get-user-role-list",
        saveUserRoleData: ICDC_APIBaseURL + "/ms-role/save-user-role",
        setDefaultRole: ICDC_APIBaseURL + "/ms-role/set-default",
        delUser: ICDC_APIBaseURL + "/ms-role/del-user",
      },
      leaderWisdom: {
        getListLeaderWisdoms: ICDC_APIBaseURL + "/leader-wisdom/get-list",
        getLeaderWisdom: ICDC_APIBaseURL + "/leader-wisdom/get",
        addLeaderWisdom: ICDC_APIBaseURL + "/leader-wisdom/add",
        updateLeaderWisdom: ICDC_APIBaseURL + "/leader-wisdom/update",
        setSequenceLeaderWisdom: ICDC_APIBaseURL + "/leader-wisdom/set-sequence",
        deleteLeaderWisdom: ICDC_APIBaseURL + "/leader-wisdom/del",
        getLeaderStatus: ICDC_APIBaseURL + "/leader-wisdom/get-wisdom-status",
      },
      personalWisdom: {
        getListPersonalWisdoms: ICDC_APIBaseURL + "/personal-wisdom/get-list",
        getPersonalWisdom: ICDC_APIBaseURL + "/personal-wisdom/get",
        getMyPersonalWisdom: ICDC_APIBaseURL + "/personal-wisdom/get-my-wisdom",
        addPersonalWisdom: ICDC_APIBaseURL + "/personal-wisdom/add",
        updatePersonalWisdom: ICDC_APIBaseURL + "/personal-wisdom/update-staff",
        updateMyPersonalWisdom: ICDC_APIBaseURL + "/personal-wisdom/update-my-wisdom",
        deletePersonalWisdom: ICDC_APIBaseURL + "/personal-wisdom/del",
        getPersonalStatus: ICDC_APIBaseURL + "/personal-wisdom/get-wisdom-status",
      },
      testimony: {
        getListTestimony: ICDC_APIBaseURL + "/testimony/get-list",
        getTestimony: ICDC_APIBaseURL + "/testimony/get",
        getMyTestimony: ICDC_APIBaseURL + "/testimony/get-my-testimony",
        addTestimony: ICDC_APIBaseURL + "/testimony/add",
        updateTestimony: ICDC_APIBaseURL + "/testimony/update-staff",
        updateMyTestimony: ICDC_APIBaseURL + "/testimony/update-my-testimony",
        deleteTestimony: ICDC_APIBaseURL + "/testimony/del",
        getTestimonyStatus: ICDC_APIBaseURL + "/testimony/get-testimony-status",
      },
      content: {
        getListContent: ICDC_APIBaseURL + "/content/get-list",
        getContent: ICDC_APIBaseURL + "/content/get",
        addContent: ICDC_APIBaseURL + "/content/add",
        updateContent: ICDC_APIBaseURL + "/content/update",
        deleteContent: ICDC_APIBaseURL + "/content/del",
      },
      landingPage: {
        getListContent: ICDC_APIBaseURL + "/landing-page/get-content-list",
        getConfig: ICDC_APIBaseURL + "/landing-page/get-config",
        saveConfig: ICDC_APIBaseURL + "/landing-page/save",
        checkPageSection: ICDC_APIBaseURL + "/landing-page/check-page-section",
        getSectionType: ICDC_APIBaseURL + "/landing-page/get-section-type",
        getSectionColumn: ICDC_APIBaseURL + "/landing-page/get-section-column",
        getSectionView: ICDC_APIBaseURL + "/landing-page/get-section-view",
        getSectionPreview: ICDC_APIBaseURL + "/landing-page/get-section-preview",
        getContent: ICDC_APIBaseURL + "/landing-page/content",
      },
      homePage: {
        getListContent: ICDC_APIBaseURL + "/home-page/get-content-list",
        getConfig: ICDC_APIBaseURL + "/home-page/get-config",
        saveConfig: ICDC_APIBaseURL + "/home-page/save",
        checkPageSection: ICDC_APIBaseURL + "/home-page/check-page-section",
        getSectionType: ICDC_APIBaseURL + "/home-page/get-section-type",
        getSectionColumn: ICDC_APIBaseURL + "/home-page/get-section-column",
        getSectionView: ICDC_APIBaseURL + "/home-page/get-section-view",
        getSosialMediaDetail: ICDC_APIBaseURL + "/home-page/get-sosial-media-detail",
        getSectionPreview: ICDC_APIBaseURL + "/home-page/get-section-preview",
        getTargetAudience: ICDC_APIBaseURL + "/home-page/get-target-audience",
      },
      selfReport: {
        getReport: ICDC_APIBaseURL + "/self-report/get",
        getFacilitator: ICDC_APIBaseURL + "/self-report/get-facilitator",
        getCoachMentorBudy: ICDC_APIBaseURL + "/self-report/get-coach-mentor-budy",
        getSummaryCoachMentorBudy: ICDC_APIBaseURL + "/self-report/get-summary-cmb",
        postSubmitReport: ICDC_APIBaseURL + "/self-report/submit",
        getListReport: ICDC_APIBaseURL + "/self-report/get-list",
        postApprove: ICDC_APIBaseURL + "/self-report/approve",
        postReject: ICDC_APIBaseURL + "/self-report/reject",
        getTotalDuration: ICDC_APIBaseURL + "/self-report/get-total-duration",
        getToDoList: ICDC_APIBaseURL + "/self-report/get-todo-list",
        downloadTemplateCoachingProgrammeCommitment: ICDC_APIBaseURL + "/self-report/download-template/coaching-programme-commitment"
      },
      file: {
        uploadImage: ICDC_APIBaseURL + "/file/upload-image",
        uploadFile: ICDC_APIBaseURL + "/file/upload-file",
        uploadFileTinymce: ICDC_APIBaseURL + "/file/upload-file-tinymce",
        downloadBase64: ICDC_APIBaseURL + "/file/download-base-64",
        getSpCdnFile: ICDC_APIBaseURL + "/file/sp-cdn-file",
        getSpCdnFileMedia: ICDC_APIBaseURL + "/file/sp-cdn-file-media",
      },
      dashboard: {
        postTna: ICDC_APIBaseURL + "/dashboard/get-tna",
        getCurriculum: ICDC_APIBaseURL + "/dashboard/get-curriculum",
        getExternal: ICDC_APIBaseURL + "/dashboard/get-external",
        getPesonalWisdom: ICDC_APIBaseURL + "/dashboard/get-my-selected-wisdom",
      },
      event: {
        selfRegister: ICDC_APIBaseURL + "/event/self-register",
        assignTraining: ICDC_APIBaseURL + "/event/assign-training",
        getSubordinate: ICDC_APIBaseURL + "/event/get-subordinate",
        getList: ICDC_APIBaseURL + "/event/get-list",
        getDetail: ICDC_APIBaseURL + "/event/get",
        approval: ICDC_APIBaseURL + "/event/approval",
      },
      footer: {
        getConfig: ICDC_APIBaseURL + "/footer-page/get-config",
        saveConfig: ICDC_APIBaseURL + "/footer-page/save",
      },
      notification: {
        getToDoNotificationReadStatus: ICDC_APIBaseURL + "/notification/to-do-read-status",
        setToDoNotificationReadStatus: ICDC_APIBaseURL + "/notification/set-to-do-read-status",
      }
    },
  },
  bcc: {},
  beelajar: {
    externalTrainingRequest: 'https://beelajarlms.apps.binus.edu/local/training_request/index.php',
    postRequestLogin: beelajar_APIBaseURL,
    getTodoList: setUrlBeelajar("local_api_beelajar20_get_data_todolist"),
    getTrainingOverview: setUrlBeelajar("local_api_beelajar20_get_data_training_overview"),
    getImageMoodle: (url) => {
      return url + '?token=' + imageMoodleToken;
    },
    getProgramMonitoring: setUrlBeelajar("local_api_beelajar20_get_data_program_monitoring"),
    getTrainingOverviewSchool: setUrlBeelajar("local_api_beelajar20_get_data_training_overview_school"),
    getTrainingOpenCourse: setUrlBeelajar("local_api_beelajar20_get_data_training_open_course"),
    getProgramName: setUrlBeelajar("local_api_beelajar20_get_data_program_name"),
    getEvent: setUrlBeelajar("local_api_beelajar20_get_data_course_event"),
    getCountEvent: setUrlBeelajar("local_api_beelajar20_get_data_count_course_event"),
    getEventDetail: setUrlBeelajar("local_api_beelajar20_get_data_course_event_detail"),
    getEventList: setUrlBeelajar("local_api_beelajar20_get_data_course_event_list"),
    getEventCategory: setUrlBeelajar("local_api_beelajar20_get_data_categories"),
    getEventTag: setUrlBeelajar("local_api_beelajar20_get_data_tags"),
    getCourseCompletion: setUrlBeelajar("local_api_beelajar20_get_data_course_completion"),
    getCompletedCurriculum: setUrlBeelajar("local_api_beelajar20_get_data_curriculum"),
    getModularTraining: setUrlBeelajar("local_api_beelajar20_get_data_modular_training"),
    getFacilitatorProfile: setUrlBeelajar("local_api_beelajar20_get_data_facilitator_profile"),
    getDataTestimony: setUrlBeelajar("local_api_beelajar20_get_data_testimony"),
    getTrainingCertificates: setUrlBeelajar("local_api_beelajar20_get_data_training_certificate"),
  },
  bclndFrontEnd: {
    doLogin: BCLnDFrontEnd_APIBaseURL + "/auth/dogetlogin",
  },
  bclndOldBackEnd: {
    doLogin: BCLnDOldBackEnd_BaseURL + "/login.aspx"
  },
  bclndNewBackEnd: {
    doLogin: BCLnDNewBackEnd_APIBaseURL + "/Login/GetAuth",
  },
  fma: {
    doLogin: Fma_APIBaseURL + "/login?isLoginSso=1&source=beelajar",
  },
};